import { useWindowSize } from "@components/window-size-provider";
import { LinkProps } from "@customTypes/index";
import { Button, Col, Divider, Row } from "antd";
import useMapCmsToScreenSize from "@hooks/useMapCmsToScreenSize";

interface AdDividerCtaProps {
    className?: string | undefined,
    link?: LinkProps;
    displayOn?: string[];
}

const defaultProps: AdDividerCtaProps = {};

const AdDividerCta = ({ className, link, displayOn = [] }: AdDividerCtaProps) => {
    const css: string[] = ["ad-divider-cta"];
    const windowDimensions = useWindowSize();
    const showAdDivider = useMapCmsToScreenSize(windowDimensions, displayOn);

    return (
        <>
            {showAdDivider && <div className={css.join(' ')}>
                <Divider />
                <Row
                    justify={`space-between`}
                    align={`middle`}
                >
                    <Col>
                        <h3>
                            <small>
                                Sign Up To
                            </small>
                            <br />
                            <strong>Covr</strong>Price
                        </h3>
                    </Col>
                    <Col>
                        {link
                            && <Button
                                className="learn-more-btn"
                                shape={`round`}
                                size={`small`}
                                href={link.url}
                                type={`default`}
                                target={link.target}
                            >
                                {link.title}
                            </Button>
                        }
                    </Col>
                </Row>
                <Divider />
            </div>}
        </>
    );
};

AdDividerCta.defaultProps = defaultProps;

export default AdDividerCta;
